const NAME = "FUNCTIONARY_TYPES_SETTINGS";

export default NAME;
